import { ArtsAJAXFormComments } from './core';
import './core/types';
const instance = new ArtsAJAXFormComments(window.artsAJAXFormComments);
export default instance.init();
